import appbarTheme from "css/themes/homePage/appbarTheme.css";
import { bool, func } from "prop-types";
import React from "react";

class ClosedSearchBar extends React.Component {
  static proptypes = {
    onclick: func.isRequired,
    lightBackground: bool,
  };

  render() {
    const { lightBackground } = this.props;

    let { onclick } = this.props;

    return (
      <div
        onClick={(e) => onclick()}
        style={{
          paddingTop: "7px",
        }}
      >
        {lightBackground ? (
          <img src="/images/icons/ink-mag-glass.svg" />
        ) : (
          <img src="/images/icons/white-mag-glass.svg" />
        )}
      </div>
    );
  }
}

export default ClosedSearchBar;
